import {
  Button,
  Popconfirm,
  Space,
  Switch,
  Tooltip,
} from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import Table from "../../../shared/components/ui/Table";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { cMSService } from "../../../shared/services";
import { useCMS, useTableCMS } from "../hook";
import { DataCMS } from "../../../redux/@types/cms";

export const TableCMS = () => {
  const { changeCMSForUpdate, removeCMS } = useTableCMS();
  const { setTableProps, updateStatus, isLoading } = useCMS();

  const columns: TableColumns<DataCMS> = [
    {
      title: "ID",
      width: 80,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Título",
      dataIndex: "title",
      key: "title",
      filterType: "text",
      render: (title: string) => <strong>{title}</strong>,
    },
    {
      title: "Estado",
      width: 140,
      dataIndex: "status",
      key: "status",
      render: (_, item) => (
        <Switch
          checked={item.status === "active"}
          disabled={isLoading}
          checkedChildren="Activo"
          unCheckedChildren="Inactivo"
          onChange={(checked) =>
            updateStatus(checked ? "active" : "inactive", item.id)
          }
        />
      ),
      filters: [
        { text: "Activo", value: "active" },
        { text: "Inactivo", value: "inactive" },
      ],
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 120,
      render: (_, item) => (
        <Space>
          <Tooltip title="Editar">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => changeCMSForUpdate(item as DataCMS)}
            />
          </Tooltip>
          <Popconfirm
            title="¿Eliminar este contenido?"
            description={`Se eliminará "${item.title}". Esta acción no se puede deshacer.`}
            okText="Eliminar"
            cancelText="Cancelar"
            okButtonProps={{ danger: true }}
            onConfirm={() => removeCMS(item.id)}
          >
            <Tooltip title="Eliminar">
              <Button type="text" danger icon={<DeleteOutlined />} />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table<DataCMS>
      columns={columns}
      fetchQueryProps={{
        $sort: { id: -1 },
      }}
      service={cMSService}
      onLoad={setTableProps}
    />
  );
};
